export default "__VITE_ASSET__83058f19__"